import {Platform, StyleSheet} from 'react-native';

import platformConfig from '/config/platform.config';
import {cloudLightest, white} from '/theme/color/on.color';
import {codGray, denim, pearl} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 20,
    paddingVertical: 20,
  },
  base: {
    backgroundColor: cloudLightest,
    width: '100%',
    paddingVertical: 10,
    marginVertical: 5,
  },
  scrollViewContainer: {
    maxHeight: 150,
  },
  modal: {
    backgroundColor: white,
    width: 500,
    height: '100vh' as any,
    margin: 0,
    alignSelf: 'flex-end',
  },
  modalView: {
    flex: 1,
    height: '100vh' as any,
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    paddingTop: Platform.OS === 'ios' ? 16 : 0,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 120,
  },
  scrollContentKeyboard: {
    paddingBottom: 200,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: Platform.OS === 'ios' ? 0 : 10,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  rankText: {
    fontSize: 14,
    marginVertical: 10,
    fontWeight: 'bold',
  },
  filterText: {
    fontSize: 15.5,
    marginLeft: 20,
    marginVertical: 10,
  },
  filterTextVal: {
    fontSize: 15,
    fontWeight: '400',
    marginTop: 10,
    marginRight: 5,
  },
  applyFiltersText: {
    fontSize: 16,
    position: 'absolute',
    paddingTop: 10,
    right: 20,
    color: denim,
  },
  buttonWidth: {
    // @ts-expect-error TS(2322): Type '"fit-content"' is not assignable to type 'Di... Remove this comment to see the full error message
    width: 'fit-content',
  },

  viewContainer: {
    flexDirection: 'row',
  },
  verticalContainer: {
    flexDirection: 'column',
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  popovetTextTitle: {
    fontWeight: platformConfig.select({ios: '600', android: 'bold'}),
  },
  filtersButtonContainer: {
    marginTop: 10,
  },
  clearButton: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 6,
    paddingVertical: 9,
    paddingHorizontal: 20,
    backgroundColor: '#fff',
  },
  clearText: {
    color: '#333',
    fontWeight: '600',
  },
  applyButton: {
    backgroundColor: denim,
    borderRadius: 6,
    paddingVertical: 9,
    paddingHorizontal: 20,
  },
  applyText: {
    color: '#fff',
    fontWeight: '600',
  },
  actioncontainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: '#fff',
  },
  filterSection: {
    marginVertical: 10,
  },

  sectionTitle: {
    fontSize: 16,
    marginBottom: 8,
  },

  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingLeft: 10,
  },

  checkboxIcon: {
    fontSize: 20,
    borderRadius: 2,
    color: pearl,
    backgroundColor: codGray,
    marginRight: 12,
  },

  checkboxIconSelected: {
    fontSize: 20,
    color: denim, // Selected color
    borderRadius: 2,
    backgroundColor: 'transparent',
  },

  checkboxLabel: {
    fontSize: 15,
    color: codGray,
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    flexWrap: 'wrap',
  },
  fixedButtonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingTop: 6,
    paddingBottom: 20,
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: '#ddd',
  },
  closeIcon: {},
});

export const getCheckboxStyle = (selected: boolean) => ({
  icon: [styles.checkboxIcon, selected && styles.checkboxIconSelected],
});

export const useModalStyles = () => styles;
